import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';

/**
 * The sample library — the demo's no-login source.
 *
 * A service in name only, so that "Transferred from the sample library" comes
 * out of the same field as "Transferred from Spotify" and no screen has to
 * know whether the visitor signed in.
 */
export const sampleLibrary: MusicService = {
  id: 'sample-library',
  name: 'Sample library',
  shortName: 'Sample',
  isSupported: false,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#FFB020',
    label: '#B77400',
    background: '#1A1430',
  },
  /**
   * What the sample library holds.
   *
   * A source is read, never written to, but the wizard decides what a transfer
   * may carry from the intersection of both ends' capabilities — so the source
   * has to claim everything the corpus actually contains, or the picker offers
   * less than the file does.
   */
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: true,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: true,
    doesSupportFetchingLibraryAlbums: true,
    doesSupportFetchingAlbums: true,
    doesSupportFetchingAlbumTracks: true,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: true,
    doesSupportFetchingLibraryArtists: true,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: true,
    doesSupportRemovingArtistsFromLibrary: true,
    doesSupportSearchByISRC: true,
    doesReturnISRC: true,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: false,
    doesReturnUserCountry: false,
    maxLimit: 50,
  },
  importerID: ImporterID.Sample,
  musicAPIID: MusicAPIIntegrationID.Sample,
};
